import * as THREE from 'three'

export default class OffscreenArrow
{
    constructor(_options)
    {
        this.camera = _options.camera
        this.position = _options.position.clone()
        this.projected = new THREE.Vector3()
        this.cameraDirection = new THREE.Vector3()
        this.toTarget = new THREE.Vector3()

        this.container = document.createElement('div')
        this.container.className = 'offscreen-indicator'
        this.container.setAttribute('aria-hidden', 'true')
        this.container.hidden = true
        this.pin = document.createElement('div')
        this.pin.className = 'offscreen-indicator-pin'
        this.arrow = document.createElement('div')
        this.arrow.className = 'offscreen-indicator-arrow'
        this.container.append(this.pin, this.arrow)
        document.body.appendChild(this.container)
    }

    update(_visible = true)
    {
        if(!_visible)
        {
            this.container.hidden = true
            return
        }

        const camera = this.camera.instance
        camera.updateMatrixWorld()
        this.projected.copy(this.position).project(camera)
        camera.getWorldDirection(this.cameraDirection)
        this.toTarget.copy(this.position).sub(camera.position)
        const behind = this.toTarget.dot(this.cameraDirection) < 0
        const width = window.innerWidth
        const height = window.innerHeight
        const centerX = width * 0.5
        const centerY = height * 0.5
        const margin = 48
        let x = (this.projected.x * 0.5 + 0.5) * width
        let y = (- this.projected.y * 0.5 + 0.5) * height
        const onScreen = !behind && this.projected.z >= -1 && this.projected.z <= 1 && x >= margin && x <= width - margin && y >= margin && y <= height - margin
        this.container.hidden = onScreen
        if(onScreen)
            return
        if(behind)
        {
            x = centerX - (x - centerX)
            y = centerY - (y - centerY)
        }
        const deltaX = x - centerX
        const deltaY = y - centerY
        const scale = Math.min(
            (centerX - margin) / Math.max(Math.abs(deltaX), 0.0001),
            (centerY - margin) / Math.max(Math.abs(deltaY), 0.0001)
        )
        const edgeX = centerX + deltaX * scale
        const edgeY = centerY + deltaY * scale
        const angle = Math.atan2(deltaY, deltaX)
        this.container.style.transform = `translate(${edgeX}px, ${edgeY}px) translate(-50%, -50%)`
        this.arrow.style.transform = `rotate(${angle}rad)`
    }

    remove()
    {
        this.container.remove()
    }
}
